import { inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { GetSounds } from "src/app/store/sounds/sounds.action";

export function SoundsResolver() {
    return inject(Store).dispatch(new GetSounds());
}